import { render, staticRenderFns } from "./email-test.vue?vue&type=template&id=32a7375e&scoped=true"
import script from "./email-test.vue?vue&type=script&lang=js"
export * from "./email-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a7375e",
  null
  
)

export default component.exports